import { useEffect, useState } from "react";
import LeaderOrder from "./LeaderOrder";
import { useSelector } from "react-redux";
import { formatPrice } from "utils";

const LeaderOrderContainer = ({isBulkOrder = false}: any) => {

    const [requestReasonDetailData, setRequestReasonDetailData] = useState<any>({'growth':[], 'planned' : [], 'unPlanned' : []});


    const {
        orderByIdValue,
    }:any = useSelector((state:any)=>({
        orderByIdValue: state.OrderReducer.orderByIdData
    }))

    useEffect(() => {
        if (orderByIdValue?.requests?.length > 0) {
            let planned: any[] = [];
            let unPlannedgrowth: any[] = [];
            let growth: any[] = [];
            orderByIdValue.requests?.forEach((vehicles: any, i: any) => {
                vehicles?.reasons?.forEach((reason: any) => {
                    if(reason?.approximateDisposeValue && (typeof(reason?.approximateDisposeValue) === "number" )){
                        reason.approximateDisposeValue = '$' +  formatPrice(reason?.approximateDisposeValue, 2)
                     }
                     if(reason?.mileageHourMeter && (typeof(reason?.mileageHourMeter) === "number" )){
                        reason.mileageHourMeter = formatPrice(reason?.mileageHourMeter, 1)
                     }
                     if(reason?.netBookedValue && (typeof(reason?.netBookedValue) === "number" )){
                        reason.netBookedValue = '$' +  reason?.netBookedValue?.toFixed(2)
                     }
                    if (reason?.reasonType == 'Growth') {
                        let growthArr = [...growth];
                        if (growth[i]?.length > 0)
                            growthArr[i] = [...growth[i], reason];
                        else
                            growthArr[i] = [reason];
                        growth = [...growthArr];
                    } else if (reason?.reasonType == 'Planned') {
                        let plannedArr = [...planned];
                        if (planned[i]?.length > 0)
                            plannedArr[i] = [...planned[i], reason];
                        else
                            plannedArr[i] = [reason];
                        planned = [...plannedArr];
                    } else if (reason?.reasonType == 'Unplanned') {
                        let unPlannedArray = [...unPlannedgrowth];
                        if (unPlannedgrowth[i]?.length > 0){
                            unPlannedArray[i] = [...unPlannedgrowth[i], reason];
                        }
                        else{
                        unPlannedArray[i] = [reason];
                        }
                        unPlannedgrowth = [...unPlannedArray];
                    }
                })
            })
            setRequestReasonDetailData({'growth':growth, 'planned': planned , 'unPlanned' : unPlannedgrowth})
        }
    }, [orderByIdValue])

    return <LeaderOrder requestReasonDetailData={requestReasonDetailData} orderByIdValue = {orderByIdValue} isBulkOrder={isBulkOrder}/>
}

export default LeaderOrderContainer;
